import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface MobileLoadingProps {
  className?: string;
  message?: string;
  fullScreen?: boolean;
}

export function MobileLoading({ 
  className, 
  message,
  fullScreen = false 
}: MobileLoadingProps) {
  const { t } = useTranslation('common');
  const displayMessage = message ?? t('loading', 'Loading...');

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
        <div className="flex flex-col items-center gap-4 p-6">
          <div className="relative">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <div className="absolute inset-0 h-8 w-8 rounded-full border-2 border-primary/30 animate-pulse" />
          </div>
          <p className="text-sm font-medium text-muted-foreground">{displayMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-3 justify-center py-8", className)}>
      <div className="relative">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
        <div className="absolute inset-0 h-6 w-6 rounded-full border border-primary/30 animate-pulse" />
      </div>
      <span className="text-sm font-medium text-muted-foreground">{displayMessage}</span>
    </div>
  );
}
